import { Flex, HStack, IconButton, Text, useColorModeValue } from '@chakra-ui/react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import React from 'react'
import { useLanguage } from '../../hooks/utility/useLanguage'

interface QuestionHeaderProps {
  prompt: string
  isMulti: boolean
  currentIndex: number
  total: number
  disabled: boolean
  onPrev: () => void
  onNext: () => void
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  prompt,
  isMulti,
  currentIndex,
  total,
  disabled,
  onPrev,
  onNext,
}) => {
  const { t } = useLanguage()
  const mutedColor = useColorModeValue('gray.500', 'gray.400')
  const showStepper = total > 1
  const isFirst = currentIndex === 0
  const isLast = currentIndex === total - 1

  return (
    <Flex justify='space-between' align='center' px={5} py={4} gap={4}>
      <Text fontWeight='semibold' fontSize='md'>
        {prompt}
        {isMulti && (
          <Text as='span' fontWeight='normal' color={mutedColor}>
            {' '}{t('clarification.selectAllThatApply')}
          </Text>
        )}
      </Text>
      {showStepper && (
        <HStack spacing={1} color={mutedColor} fontSize='sm' flexShrink={0}>
          <IconButton
            aria-label={t('clarification.previousQuestion')}
            variant='ghost'
            size='xs'
            icon={<ChevronLeft size={16} />}
            isDisabled={isFirst || disabled}
            onClick={onPrev}
          />
          <Text>{t('clarification.stepCounter', { current: currentIndex + 1, total })}</Text>
          <IconButton
            aria-label={t('clarification.nextQuestion')}
            variant='ghost'
            size='xs'
            icon={<ChevronRight size={16} />}
            isDisabled={isLast || disabled}
            onClick={onNext}
          />
        </HStack>
      )}
    </Flex>
  )
}
